import { localePlugin } from '@backmarket/design-system'
import Vue from 'vue'

import { getBcp47LocaleFrom } from '@core/helpers/countries'

const plugin = (VueInstance, app, store) => {
  const country = store.getters['config/country']
  if (app.$config.FF_NEW_URL_FORMAT.includes(country)) {
    const locale = store.getters['config/locale']

    VueInstance.use(localePlugin, {
      locale: getBcp47LocaleFrom(locale),
    })
  }
}

// testing purpose
export const routerPlugin = {
  install(VueInstance, { app, store }) {
    plugin(VueInstance, app, store)
  },
}

export default ({ app, store }) => {
  plugin(Vue, app, store)
}
